// Alternative approach using CSS Grid for maximum flexibility
import React from "react";
import {
    Button,
    Card,
} from "react-bootstrap";
import EditIcon from "@mui/icons-material/Edit";

const SummaryCards = ({ summaryData, onEditClick }) => {
    const totalCards = summaryData.length + 1;
    
    // CSS Grid approach for more flexible layouts
    const gridStyle = {
        display: 'grid',
        gap: '1rem',
        marginBottom: '1.5rem',
        // Dynamic grid template based on screen size and card count
        gridTemplateColumns: `repeat(auto-fit, minmax(${totalCards > 6 ? '160px' : '180px'}, 1fr))`,
        justifyContent: 'center',
        // Ensure minimum width for readability
        '@media (max-width: 576px)': {
            gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))'
        }
    };

    return (
        <div style={gridStyle} className="summary-cards-grid">
            {summaryData.map((item, index) => (
                <Card
                    key={index}
                    className="shadow-sm border-0"
                    style={{
                        background: `linear-gradient(135deg, ${item.color}15, ${item.color}05)`,
                        borderLeft: `4px solid ${item.color}`,
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        minHeight: '140px'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-4px) scale(1.02)';
                        e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0) scale(1)';
                        e.currentTarget.style.boxShadow = '';
                    }}
                >
                    <Card.Body className="d-flex flex-column align-items-center text-center p-3 h-100 justify-content-center">
                        <div
                            className="mb-2 d-flex align-items-center justify-content-center"
                            style={{
                                width: '44px',
                                height: '44px',
                                borderRadius: '50%',
                                backgroundColor: `${item.color}20`,
                                color: item.color,
                                transition: 'all 0.3s ease'
                            }}
                        >
                            {item.icon}
                        </div>
                        <div
                            style={{
                                fontSize: "11px",
                                color: "#6c757d",
                                fontWeight: 600,
                                marginBottom: "6px",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                                lineHeight: 1.2
                            }}
                        >
                            {item.title}
                        </div>
                        <div
                            style={{
                                fontWeight: 700,
                                fontSize: "20px",
                                color: "#2c3e50",
                                wordBreak: "break-word",
                                lineHeight: 1.1
                            }}
                        >
                            {item.value}
                        </div>
                    </Card.Body>
                </Card>
            ))}
            
            {/* Edit Card */}
            <Card 
                className="shadow-sm border-0" 
                style={{ 
                    borderLeft: '4px solid #dc3545',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    minHeight: '140px',
                    background: 'linear-gradient(135deg, #dc354515, #dc354505)'
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px) scale(1.02)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0) scale(1)';
                    e.currentTarget.style.boxShadow = '';
                }}
            >
                <Card.Body className="d-flex flex-column align-items-center justify-content-center text-center p-3 h-100">
                    <div
                        className="mb-2 d-flex align-items-center justify-content-center"
                        style={{
                            width: '44px',
                            height: '44px',
                            borderRadius: '50%',
                            backgroundColor: '#dc354520',
                            color: '#dc3545',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        <EditIcon />
                    </div>
                    <div
                        style={{
                            fontSize: "11px",
                            color: "#6c757d",
                            fontWeight: 600,
                            marginBottom: "12px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px"
                        }}
                    >
                        Actions
                    </div>
                    <Button
                        size="sm"
                        variant="outline-primary"
                        onClick={onEditClick}
                        style={{
                            fontSize: '11px',
                            padding: '6px 16px',
                            borderColor: '#224B99',
                            color: '#224B99',
                            transition: 'all 0.3s ease',
                            borderRadius: '20px',
                            fontWeight: 600
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#224B99';
                            e.target.style.color = 'white';
                            e.target.style.transform = 'scale(1.05)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                            e.target.style.color = '#224B99';
                            e.target.style.transform = 'scale(1)';
                        }}
                    >
                        Edit Details
                    </Button>
                </Card.Body>
            </Card>
        </div>
    );
};

export default SummaryCards;